import bot0 from 'assets/avatars/Bot-0.png';
import bot1 from 'assets/avatars/Bot-1.png';
import bot2 from 'assets/avatars/Bot-2.png';
import bot3 from 'assets/avatars/Bot-3.png';
import bot4 from 'assets/avatars/Bot-4.png';
import bot5 from 'assets/avatars/Bot-5.png';
import bot6 from 'assets/avatars/Bot-6.png';
import bot7 from 'assets/avatars/Bot-7.png';
import bot8 from 'assets/avatars/Bot-8.png';

export const avatars = [bot0, bot1, bot2, bot3, bot4, bot5, bot6, bot7, bot8];
